import { render, staticRenderFns } from "./ButtonPushnote.vue?vue&type=template&id=8408431a&scoped=true&"
import script from "./ButtonPushnote.vue?vue&type=script&lang=js&"
export * from "./ButtonPushnote.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPushnote.vue?vue&type=style&index=0&id=8408431a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8408431a",
  null
  
)

export default component.exports